type RecursiveArray<I> = Array<RecursiveArray<I> | I>;

export const flattenArray = <T>(arr: RecursiveArray<T>): T[] =>
  arr.reduce<T[]>((acc, item) => {
    if (Array.isArray(item)) {
      return [...acc, ...flattenArray<T>(item)];
    }
    return [...acc, item];
  }, [] as T[]);
